import { store } from 'store';
import { fetchUpdateUserConfig } from 'store/slices/userConfig';
import type { ChatSidebarLayoutServerState } from 'types/userConfig/userConfig';

/**
 * שמירת מבנה סרגל השיחות לשרת (ProfileConfig.chatSidebarLayout) — עם debounce:
 * גרירת סדר / כמה שינויים רצופים מתאחדים לכתיבה אחת. ה-localStorage ממשיך להתעדכן
 * אצל הקוראים (fallback מהיר לעלייה הבאה); מקור האמת הוא השרת.
 */

const SAVE_DEBOUNCE_MS = 1200;

let pendingPatch: Partial<ChatSidebarLayoutServerState> = {};
let saveTimer: ReturnType<typeof setTimeout> | null = null;

export function persistSidebarLayoutToServer(patch: Partial<ChatSidebarLayoutServerState>): void {
  pendingPatch = { ...pendingPatch, ...patch };
  if (saveTimer) clearTimeout(saveTimer);
  saveTimer = setTimeout(() => {
    const current = store.getState().userConfig?.chatSidebarLayout ?? {};
    const merged: ChatSidebarLayoutServerState = { ...current, ...pendingPatch };
    pendingPatch = {};
    saveTimer = null;
    // בלי טוסט — שמירת רקע שקטה של מצב סרגל
    void fetchUpdateUserConfig({ chatSidebarLayout: merged }, false);
  }, SAVE_DEBOUNCE_MS);
}
